import { render, staticRenderFns } from "./cancelation.vue?vue&type=template&id=122bc38c&"
import script from "./cancelation.vue?vue&type=script&lang=js&"
export * from "./cancelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports